// 終局オーバーレイ (= DDSIM-15、 ADR-0025 §B.4 を serverless SOLO 向けに再 scope)。
//
// snapshot.outcome が "Ongoing" 以外になった時に Match.tsx が Board の上に重ねる。
// 勝敗は outcome + viewer(P1) の life で判定:
//   - "Draw"    -> DRAW
//   - "Decided" -> 自分(P1)の life <= 0 なら YOU LOSE、 それ以外は YOU WIN
// RETRY = 同条件で再 createSoloMatch (Match.tsx 側で restart)、 MENU = / へ。
// SOLO は server を持たないため旧 Issue の「接続切断 -> /connect」 動線は廃止。

import type { MatchSnapshot } from "@/bindings/MatchSnapshot";
import { Button } from "@/components/ui/button";

interface MatchResultProps {
  snapshot: MatchSnapshot;
  onRetry: () => void;
  onMenu: () => void;
}

export function MatchResult(props: MatchResultProps): JSX.Element {
  const { snapshot, onRetry, onMenu } = props;
  const me = snapshot.players[0];
  const opponent = snapshot.players[1];

  const isDraw = snapshot.outcome === "Draw";
  const defeated = me !== undefined && me.life <= 0;
  const title = isDraw ? "DRAW" : defeated ? "YOU LOSE" : "YOU WIN";
  const titleColor = isDraw
    ? "text-muted-foreground"
    : defeated
      ? "text-destructive"
      : "text-cyan-600";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="w-80 space-y-5 rounded-lg border border-border bg-background p-6 text-center shadow-xl">
        <p className={`text-4xl font-bold tracking-widest ${titleColor}`}>
          {title}
        </p>

        {/* stats: ターン数 + 最終 LP */}
        <div className="space-y-1 text-sm text-muted-foreground">
          <p>{snapshot.turn_count} ターンで決着</p>
          {me !== undefined && opponent !== undefined && (
            <p>
              LP YOU {me.life} / OPPONENT {opponent.life}
            </p>
          )}
        </div>

        <div className="flex justify-center gap-3">
          <Button onClick={onRetry}>RETRY</Button>
          <Button variant="outline" onClick={onMenu}>
            MENU
          </Button>
        </div>
      </div>
    </div>
  );
}
